export default {

    //smartCity--默认首页
    "smartCity.Home.943046-0": "警报",
    "smartCity.Home.943046-1": "切换首页",
    "smartCity.Home.943046-2": "是否退出当前账号？",
    "smartCity.Home.943046-3": "入口",
    "smartCity.Home.943046-4": "最近报警条目列表",
    "smartCity.Home.943046-5": "暂无报警信息",
    "smartCity.Home.943046-6": "最近报警已处理情况",
    "smartCity.Home.943046-7": "已处理", 
    "smartCity.Home.943046-8": "今日已处理",
    "smartCity.Home.943046-9": "今日处理数：",
    "smartCity.Home.943046-10": "今日未处理",
    "smartCity.Home.943046-11": "今日未处理数：",
    "smartCity.Home.943046-12": "设备报警数",
    "smartCity.Home.943046-13": "当前报警住户",
    "smartCity.Home.943046-14": "当前报警住户数",
    "smartCity.Home.943046-15": "当前报警设备",
    "smartCity.Home.943046-16": "当前报警设备数",
    "smartCity.Home.943046-17": "设备在线列表",
    "smartCity.Home.943046-18": "当前设备在线数",
    "smartCity.Home.943046-19": "设备离线列表",
    "smartCity.Home.943046-20": "当前设备离线数",
    "smartCity.Home.943046-21": "设备状态",
    "smartCity.Home.943046-22": "设备位置",
    "smartCity.Home.943046-23": "设备名称",
    "smartCity.Home.943046-24": "开关状态",
    "smartCity.Home.943046-25": "暂无状态信息",
    "smartCity.Home.943046-26": "智慧用电",
    "smartCity.Home.943046-27": "安全用气",
    "smartCity.Home.943046-28": "操作日志",
    "smartCity.Home.943046-29": "时间",
    "smartCity.Home.943046-30": "设备",
    "smartCity.Home.943046-31": "操作",
    "smartCity.Home.943046-32": "暂无操作日志",
    "smartCity.Home.943046-33": "系统引导",
    "smartCity.Home.943046-34": "静音",
    "smartCity.Home.943046-35": "播放",
    "smartCity.Home.943046-36": "退出登录",
    "smartCity.Home.943046-37": "设备种类",
    "smartCity.Home.943046-38": "燃气填报",
    "smartCity.Home.943046-39": "地图模式",
    "smartCity.Home.943046-40": "表格模式",
    "smartCity.Home.943046-41": "阵列模式",
    "smartCity.Home.943046-42": "返回",
    "smartCity.Home.943046-43": "上一级",
    "smartCity.Home.943046-44": "下一级",
    "smartCity.Home.943046-45": "台",
    "smartCity.Home.943046-46": "在线设备",
    "smartCity.Home.943046-47": "离线设备",
    "smartCity.Home.943046-48": "用户列表",
    "smartCity.Home.943046-49": "用户数",
    "smartCity.Home.943046-50": "户",
    "smartCity.Home.943046-51": "当日未解决告警数量",
    "smartCity.Home.943046-52": "次",
    "smartCity.Home.943046-53": "微断设备",
    "smartCity.Home.943046-54": "微断",
    "smartCity.Home.943046-55": "气感设备",
    "smartCity.Home.943046-56": "气感",
    "smartCity.Home.943046-57": "烟感设备",
    "smartCity.Home.943046-58": "烟感",
    "smartCity.Home.943046-59": "燃气电磁阀设备",
    "smartCity.Home.943046-60": "燃气电磁阀",
    "smartCity.Home.943046-61": "正常",
    "smartCity.Home.943046-62": "报警",
    "smartCity.Home.943046-63": "用户名",
    "smartCity.Home.943046-64": "搜索",
    "smartCity.Home.943046-65": "清空",
    "smartCity.Home.943046-66": "商户",
    "smartCity.Home.943046-67": "居民",
    "smartCity.Home.943046-68": "合格",
    "smartCity.Home.943046-69": "不合格",
    "smartCity.Home.943046-70": "查看图片",
    "smartCity.Home.943046-71": "编辑",
    "smartCity.Home.943046-72": "用户名：",
    "smartCity.Home.943046-73": "所属区域：",
    "smartCity.Home.943046-74": "手机号：",
    "smartCity.Home.943046-75": "用户地址：",
    "smartCity.Home.943046-76": "注册时间：",
    "smartCity.Home.943046-77": "器具名称",
    "smartCity.Home.943046-78": "高级查询",
    "smartCity.Home.943046-79": "新增",
    "smartCity.Home.943046-80": "数显",
    "smartCity.Home.943046-81": "非数显",
    "smartCity.Home.943046-82": "无",
    "smartCity.Home.943046-83": "检定",
    "smartCity.Home.943046-84": "校准",
    "smartCity.Home.943046-85": "符合",
    "smartCity.Home.943046-86": "不符合",
    "smartCity.Home.943046-87": "删除",
    "smartCity.Home.943046-88": "筛选：",
    "smartCity.Home.943046-89": "设备类型",
    "smartCity.Home.943046-90": "设备编号",
    "smartCity.Home.943046-91": "在线",
    "smartCity.Home.943046-92": "离线",
    "smartCity.Home.943046-93": "合闸",
    "smartCity.Home.943046-94": "分闸",
    "smartCity.Home.943046-95": "日常",
    "smartCity.Home.943046-96": "现场",
    "smartCity.Home.943046-97": "年检",
    "smartCity.Home.943046-98": "更多",
    "smartCity.Home.943046-99": "设备名称：",
    "smartCity.Home.943046-100": "设备编号：",
    "smartCity.Home.943046-101": "通讯时间：",
    "smartCity.Home.943046-102": "位置：",
    "smartCity.Home.943046-103": "开关状态：",
    "smartCity.Home.943046-104": "暂无设备",
    "smartCity.Home.943046-105": "实时值",
    "smartCity.Home.943046-106": "功能开关状态：",
    "smartCity.Home.943046-107": "电池类型：",
    "smartCity.Home.943046-108": "电量状态：",
    "smartCity.Home.943046-109": "电池剩余电量：",
    "smartCity.Home.943046-110": "监测状态：",
    "smartCity.Home.943046-111": "防拆：",
    "smartCity.Home.943046-112": "湿度值：",
    "smartCity.Home.943046-113": "温度值：",
    "smartCity.Home.943046-114": "供电方式：",
    "smartCity.Home.943046-115": "电池供电：",
    "smartCity.Home.943046-116": "电池电量：",
    "smartCity.Home.943046-117": "电池电压：",
    "smartCity.Home.943046-118": "电池电量百分百：",
    "smartCity.Home.943046-119": "报警信息",
    "smartCity.Home.943046-120": "未处理",
    "smartCity.Home.943046-121": "误报",
    "smartCity.Home.943046-122": "当前值：",
    "smartCity.Home.943046-123": "额定值：",
    "smartCity.Home.943046-124": "差值：",
    "smartCity.Home.943046-125": "异常码名称：",
    "smartCity.Home.943046-126": "异常码编号：",
    "smartCity.Home.943046-127": "异常码类别：",
    "smartCity.Home.943046-128": "附属信息",
    "smartCity.Home.943046-129": "暂无数据",
    "smartCity.Home.943046-130": "省",
    "smartCity.Home.943046-131": "市",
    "smartCity.Home.943046-132": "区",
    "smartCity.Home.943046-133": "乡镇",
    "smartCity.Home.943046-134": "村",
    "smartCity.Home.943046-135": "住户",
    "smartCity.Home.943046-136": "住户电话",
    "smartCity.Home.943046-137": "经度",
    "smartCity.Home.943046-138": "纬度",
    "smartCity.Home.943046-139": "安装时间",
    "smartCity.Home.943046-140": "几P设备",
    "smartCity.Home.943046-141": "历史曲线",
    "smartCity.Home.943046-142": "电压",
    "smartCity.Home.943046-143": "电流",
    "smartCity.Home.943046-144": "温度",
    "smartCity.Home.943046-145": "有功功率",
    "smartCity.Home.943046-146": "无功功率",
    "smartCity.Home.943046-147": "漏电",
    "smartCity.Home.943046-148": "电量记录",
    "smartCity.Home.943046-149": "参数设置",
    "smartCity.Home.943046-150": "过流保护",
    "smartCity.Home.943046-151": "过流跳闸定值",
    "smartCity.Home.943046-152": "过流告警定值",
    "smartCity.Home.943046-153": "过流跳闸延迟",
    "smartCity.Home.943046-154": "过流告警延迟",
    "smartCity.Home.943046-155": "过流告警投退",
    "smartCity.Home.943046-156": "退出",
    "smartCity.Home.943046-157": "投入",
    "smartCity.Home.943046-158": "过流跳闸投退",
    "smartCity.Home.943046-159": "过流跳闸闭锁",
    "smartCity.Home.943046-160": "过载保护",
    "smartCity.Home.943046-161": "过载跳闸定值",
    "smartCity.Home.943046-162": "过载告警定值",
    "smartCity.Home.943046-163": "过载跳闸延迟",
    "smartCity.Home.943046-164": "过载告警延迟",
    "smartCity.Home.943046-165": "过载告警投退",
    "smartCity.Home.943046-166": "过载跳闸投退",
    "smartCity.Home.943046-167": "过载跳闸闭锁",
    "smartCity.Home.943046-168": "漏电保护",
    "smartCity.Home.943046-169": "漏电跳闸定值",
    "smartCity.Home.943046-170": "漏电告警定值",
    "smartCity.Home.943046-171": "漏电跳闸延迟",
    "smartCity.Home.943046-172": "漏电告警延迟",
    "smartCity.Home.943046-173": "漏电告警投退",
    "smartCity.Home.943046-174": "漏电跳闸投退",
    "smartCity.Home.943046-175": "过压保护",
    "smartCity.Home.943046-176": "过压跳闸定值",
    "smartCity.Home.943046-177": "过压告警定值",
    "smartCity.Home.943046-178": "过压跳闸延迟",
    "smartCity.Home.943046-179": "过压告警延迟",
    "smartCity.Home.943046-180": "过压告警投退",
    "smartCity.Home.943046-181": "过压跳闸投退",
    "smartCity.Home.943046-182": "欠压保护",
    "smartCity.Home.943046-183": "欠压跳闸定值",
    "smartCity.Home.943046-184": "欠压告警定值",
    "smartCity.Home.943046-185": "欠压跳闸延迟",
    "smartCity.Home.943046-186": "欠压告警延迟",
    "smartCity.Home.943046-187": "欠压告警投退",
    "smartCity.Home.943046-188": "欠压跳闸投退",
    "smartCity.Home.943046-189": "过欠压恢复",
    "smartCity.Home.943046-190": "过压恢复合闸定值",
    "smartCity.Home.943046-191": "欠压恢复合闸定值",
    "smartCity.Home.943046-192": "过压恢复合闸延时",
    "smartCity.Home.943046-193": "欠压恢复合闸延时",
    "smartCity.Home.943046-194": "过压恢复合闸投退",
    "smartCity.Home.943046-195": "欠压恢复合闸投退",
    "smartCity.Home.943046-196": "电弧保护",
    "smartCity.Home.943046-197": "电弧跳闸定值",
    "smartCity.Home.943046-198": "电弧告警定值",
    "smartCity.Home.943046-199": "电弧跳闸延迟",
    "smartCity.Home.943046-200": "电弧告警延迟",
    "smartCity.Home.943046-201": "电弧告警投退",
    "smartCity.Home.943046-202": "电弧跳闸投退",
    "smartCity.Home.943046-203": "过温保护",
    "smartCity.Home.943046-204": "过温跳闸定值",
    "smartCity.Home.943046-205": "过温告警定值",
    "smartCity.Home.943046-206": "过温跳闸延迟",
    "smartCity.Home.943046-207": "过温告警延迟",
    "smartCity.Home.943046-208": "过温告警投退",
    "smartCity.Home.943046-209": "过温跳闸投退",
    "smartCity.Home.943046-210": "缺相保护",
    "smartCity.Home.943046-211": "缺相跳闸定值",
    "smartCity.Home.943046-212": "缺相告警定值",
    "smartCity.Home.943046-213": "缺相跳闸延迟",
    "smartCity.Home.943046-214": "缺相告警延迟",
    "smartCity.Home.943046-215": "缺相告警投退",
    "smartCity.Home.943046-216": "缺相跳闸投退",
    "smartCity.Home.943046-217": "连续动作闭锁",
    "smartCity.Home.943046-218": "闭锁时间",
    "smartCity.Home.943046-219": "动作次数",
    "smartCity.Home.943046-220": "三相过压恢复",
    "smartCity.Home.943046-221": "三相欠压恢复",
    "smartCity.Home.943046-222": "过欠压恢复时间",
    "smartCity.Home.943046-223": "系统参数",
    "smartCity.Home.943046-224": "电量储存间隔",
    "smartCity.Home.943046-225": "立即储存电量阈值",
    "smartCity.Home.943046-226": "间隔电量储存阈值",
    "smartCity.Home.943046-227": "电量",
    "smartCity.Home.943046-228": "升级重启最大次数",
    "smartCity.Home.943046-229": "心跳异常重启次数",
    "smartCity.Home.943046-230": "提交设置",
    "smartCity.Home.943046-231": "召测阈值",
    "smartCity.Home.943046-232": "召测阈值1",
    "smartCity.Home.943046-233": "召测阈值2",
    "smartCity.Home.943046-234": "是否解除绑定？",
    "smartCity.Home.943046-235": "密码",
    "smartCity.Home.943046-236": "确定给设备消音？",
    "smartCity.Home.943046-237": "消音",
    "smartCity.Home.943046-238": "召测",
    "smartCity.Home.943046-239": "确定分闸吗？",
    "smartCity.Home.943046-240": "确定合闸吗？",
    "smartCity.Home.943046-241": "确定关阀吗？",
    "smartCity.Home.943046-242": "关阀",
    "smartCity.Home.943046-243": "探头",
    "smartCity.Home.943046-244": "时钟",
    "smartCity.Home.943046-245": "加载中...",
    "smartCity.Home.943046-246": "用户名称",
    "smartCity.Home.943046-247": "详细地址",
    "smartCity.Home.943046-248": "类型",
    "smartCity.Home.943046-249": "请处理",
    "smartCity.Home.943046-250": "处理",
    "smartCity.Home.943046-251": "暂无告警消息",
    "smartCity.Home.943046-252": "序号",
    "smartCity.Home.943046-253": "业主姓名",
    "smartCity.Home.943046-254": "设备地址",
    "smartCity.Home.943046-255": "通讯时间",
    "smartCity.Home.943046-256": "在线状态",
    "smartCity.Home.943046-257": "所属小区",
    "smartCity.Home.943046-258": "住户地址",
    "smartCity.Home.943046-259": "业主名称",
    "smartCity.Home.943046-260": "联系电话",
    "smartCity.Home.943046-261": "报警时间",
    "smartCity.Home.943046-262": "暂无告警住户",
    "smartCity.Home.943046-263": "所属区域",
    "smartCity.Home.943046-264": "注册时间",
    "smartCity.Home.943046-265": "暂无用户",
    "smartCity.Home.943046-266": "探头名称",
    "smartCity.Home.943046-267": "当前浓度值",
    "smartCity.Home.943046-268": "报警状态",
    "smartCity.Home.943046-269": "创建时间",
    "smartCity.Home.943046-270": "暂无探头",
    "smartCity.Home.943046-271": "设备详情",
    "smartCity.Home.943046-272": "所属城市",
    "smartCity.Home.943046-273": "地址",
    "smartCity.Home.943046-274": "幢",
    "smartCity.Home.943046-275": "单元",
    "smartCity.Home.943046-276": "楼层",
    "smartCity.Home.943046-277": "用户号",
    "smartCity.Home.943046-278": "业主电话",
    "smartCity.Home.943046-279": "维修人姓名",
    "smartCity.Home.943046-280": "维修人电话",
    "smartCity.Home.943046-281": "维修人身份证号码",
    "smartCity.Home.943046-282": "维修时间",
    "smartCity.Home.943046-283": "维修信息",
    "smartCity.Home.943046-284": "维修人身份证图片",
    "smartCity.Home.943046-285": "确定",
    "smartCity.Home.943046-286": "编辑用户",
    "smartCity.Home.943046-287": "请输入幢",
    "smartCity.Home.943046-288": "请输入单元",
    "smartCity.Home.943046-289": "请输入楼层",
    "smartCity.Home.943046-290": "请输入用户号",
    "smartCity.Home.943046-291": "请输入业主姓名",
    "smartCity.Home.943046-292": "请输入业主电话",
    "smartCity.Home.943046-293": "用户类型",
    "smartCity.Home.943046-294": "请选择用户类型",
    "smartCity.Home.943046-295": "单位名称",
    "smartCity.Home.943046-296": "请输入单位名称",
    "smartCity.Home.943046-297": "区域管理员电话",
    "smartCity.Home.943046-298": "请输入区域管理员电话",
    "smartCity.Home.943046-299": "年检状态",
    "smartCity.Home.943046-300": "请选择年检状态",
    "smartCity.Home.943046-301": "搜索地址",
    "smartCity.Home.943046-302": "请输入详细地址",
    "smartCity.Home.943046-303": "使用年限",
    "smartCity.Home.943046-304": "请输入使用年限",
    "smartCity.Home.943046-305": "区域管理员",
    "smartCity.Home.943046-306": "请输入区域管理员",
    "smartCity.Home.943046-307": "检定证书有效期",
    "smartCity.Home.943046-308": "请选择日期",
    "smartCity.Home.943046-309": "是否有主机",
    "smartCity.Home.943046-310": "请选择",
    "smartCity.Home.943046-311": "有",
    "smartCity.Home.943046-312": "没有",
    "smartCity.Home.943046-313": "是否有平台",
    "smartCity.Home.943046-314": "是否有短信提示",
    "smartCity.Home.943046-315": "是否有声光报警",
    "smartCity.Home.943046-316": "是否有切断",
    "smartCity.Home.943046-317": "是否有风机",
    "smartCity.Home.943046-318": "探头数量",
    "smartCity.Home.943046-319": "请输入探头数量",
    "smartCity.Home.943046-320": "法人姓名",
    "smartCity.Home.943046-321": "请输入法人姓名",
    "smartCity.Home.943046-322": "请输入联系电话",
    "smartCity.Home.943046-323": "日期",
    "smartCity.Home.943046-324": "选择日期",
    "smartCity.Home.943046-325": "自检",
    "smartCity.Home.943046-326": "异常",
    "smartCity.Home.943046-327": "电源",
    "smartCity.Home.943046-328": "巡检",
    "smartCity.Home.943046-329": "报警设备运行情况",
    "smartCity.Home.943046-330": "故障",
    "smartCity.Home.943046-331": "联动设备运行情况",
    "smartCity.Home.943046-332": "报警部位原因及处理情况",
    "smartCity.Home.943046-333": "请输入",
    "smartCity.Home.943046-334": "值班人",
    "smartCity.Home.943046-335": "取消",
    "smartCity.Home.943046-336": "探测器序号",
    "smartCity.Home.943046-337": "现场动作值记录",
    "smartCity.Home.943046-338": "准用",
    "smartCity.Home.943046-339": "处理意见",
    "smartCity.Home.943046-340": "可以使用",
    "smartCity.Home.943046-341": "标定",
    "smartCity.Home.943046-342": "更换探头",
    "smartCity.Home.943046-343": "点检人",
    "smartCity.Home.943046-344": "检查试验内容",
    "smartCity.Home.943046-345": "检查试验结果",
    "smartCity.Home.943046-346": "仪器自检",
    "smartCity.Home.943046-347": "排除情况",
    "smartCity.Home.943046-348": "备注",
    "smartCity.Home.943046-349": "检查人",
    "smartCity.Home.943046-350": "设备报警",
    "smartCity.Home.943046-351": "设备'{0}'在{1}发生{2}报警，请及时处理",
    "smartCity.Home.943046-352": "查看详情",
    "smartCity.Home.943046-353": "编辑设备",
    "smartCity.Home.943046-354": "设备编码",
    "smartCity.Home.943046-355": "请输入设备编码",
    "smartCity.Home.943046-356": "请输入设备名称",
    "smartCity.Home.943046-357": "联系人",
    "smartCity.Home.943046-358": "请输入联系人",
    "smartCity.Home.943046-359": "设备图片",
    "smartCity.Home.943046-360": "确认删除这张图片吗?",
    "smartCity.Home.943046-361": "时钟设置",
    "smartCity.Home.943046-362": "设置时间",
    "smartCity.Home.943046-363": "设备时钟",
    "smartCity.Home.943046-364": "设置时钟",
    "smartCity.Home.943046-365": "读取时钟",
    "smartCity.Home.943046-366": "修改操作密码",
    "smartCity.Home.943046-367": "原密码",
    "smartCity.Home.943046-368": "请输入密码",
    "smartCity.Home.943046-369": "新密码",
    "smartCity.Home.943046-370": "确认密码",
    "smartCity.Home.943046-371": "新增在用燃气报警器",
    "smartCity.Home.943046-372": "编辑在用燃气报警器",
    "smartCity.Home.943046-373": "显示方式",
    "smartCity.Home.943046-374": "器具类型",
    "smartCity.Home.943046-375": "使用单位",
    "smartCity.Home.943046-376": "使用单位统一社会信用代码",
    "smartCity.Home.943046-377": "供气单位",
    "smartCity.Home.943046-378": "型号规格",
    "smartCity.Home.943046-379": "出厂编号",
    "smartCity.Home.943046-380": "生产厂家统一社会信用代码",
    "smartCity.Home.943046-381": "生产厂家",
    "smartCity.Home.943046-382": "型式批准证书号",
    "smartCity.Home.943046-383": "安装地点",
    "smartCity.Home.943046-384": "量值溯源方式",
    "smartCity.Home.943046-385": "量值溯源机构",
    "smartCity.Home.943046-386": "量值溯源日期",
    "smartCity.Home.943046-387": "证书编号",
    "smartCity.Home.943046-388": "计量性能符合性",
    "smartCity.Home.943046-389": "查询",
    "smartCity.Home.943046-390": "请输入下拉项",
    "smartCity.Home.943046-391": "修改",
    "smartCity.Home.943046-392": "是否删除该下拉项？",
    "smartCity.Home.943046-393": "一键导入",
    "smartCity.Home.943046-394": "查看",
    "smartCity.Home.943046-395": "数据中心",
    "smartCity.Home.943046-396": "跳过",
    "smartCity.Home.943046-397": "浙江省-杭州市",
    "smartCity.Home.943046-398": "用户地址",
    "smartCity.Home.943046-399": "气体报警器个数",
    "smartCity.Home.943046-400": "燃气电磁阀个数",
    "smartCity.Home.943046-401": "位置",
    "smartCity.Home.943046-402": "控制器运行情况",
    "smartCity.Home.943046-403": "防火负责人",
    "smartCity.Home.943046-404": "设备检测数据",
    "smartCity.Home.943046-405": "今日能耗分时统计",
    "smartCity.Home.943046-406": "单位（kw·h）",
    "smartCity.Home.943046-407": "请选择智慧用电进入系统",
    "smartCity.Home.943046-408": "请选择安全用气进入系统",
    "smartCity.Home.943046-409": "区域选择",
    "smartCity.Home.943046-410": "请选择您要查看的市级数据",
    "smartCity.Home.943046-411": "左侧菜单",
    "smartCity.Home.943046-412": "选择不同的左侧菜单即可查看不同层级的数据",
    "smartCity.Home.943046-413": "上层标签",
    "smartCity.Home.943046-414": "此按钮展示左侧菜单的上层区域，点击可查看上级数据",
    "smartCity.Home.943046-415": "此模式可以对燃气安全信息内容进行相关操作",
    "smartCity.Home.943046-416": "燃气填报主要区域",
    "smartCity.Home.943046-417": "此模式下各层级数据以地图的形式展现",
    "smartCity.Home.943046-418": "地图模式主要区域",
    "smartCity.Home.943046-419": "此模式下各层级数据以表格的形式展现",
    "smartCity.Home.943046-420": "双击列表行数据或者点击用户名称进入设备列表界面",
    "smartCity.Home.943046-421": "无用户数据",
    "smartCity.Home.943046-422": "设备列表",
    "smartCity.Home.943046-423": "设备数据以表格形式呈现",
    "smartCity.Home.943046-424": "点击可以返回上层",
    "smartCity.Home.943046-425": "此模式下各层级数据以阵列的形式展现",
    "smartCity.Home.943046-426": "用户阵列",
    "smartCity.Home.943046-427": "点击一项数据进入设备阵列界面",
    "smartCity.Home.943046-428": "设备阵列",
    "smartCity.Home.943046-429": "设备数据以阵列形式呈现",
    "smartCity.Home.943046-430": "提示",
    "smartCity.Home.943046-431": "是否删除",
    "smartCity.Home.943046-432": "请先填写必填项!",
    "smartCity.Home.943046-433": "请求超时",
    "smartCity.Home.943046-434": "日常维护检查记录",
    "smartCity.Home.943046-435": "年（季）检查记录",
    "smartCity.Home.943046-436": "探头列表",
    "smartCity.Home.943046-437": "操作密码",
    "smartCity.Home.943046-438": "请输入操作密码",
    "smartCity.Home.943046-439": "原密码不能为空",
    "smartCity.Home.943046-440": "新密码不能为空",
    "smartCity.Home.943046-441": "请确认密码",
    "smartCity.Home.943046-442": "两次密码不相同",
    "smartCity.Home.943046-443": "修改密码成功",
    "smartCity.Home.943046-444": "您的操作太频繁，请稍后...",
    "smartCity.Home.943046-445": "操作中",
    "smartCity.Home.943046-446": "召测中",
    "smartCity.Home.943046-447": "请先完成必填项",
    "smartCity.Home.943046-448": "A相电压",
    "smartCity.Home.943046-449": "B相电压",
    "smartCity.Home.943046-450": "C相电压",
    "smartCity.Home.943046-451": "A相电流",
    "smartCity.Home.943046-452": "B相电流",
    "smartCity.Home.943046-453": "C相电流",
    "smartCity.Home.943046-454": "A相温度",
    "smartCity.Home.943046-455": "B相温度",
    "smartCity.Home.943046-456": "C相温度",
    "smartCity.Home.943046-457": "A相有功功率",
    "smartCity.Home.943046-458": "B相有功功率",
    "smartCity.Home.943046-459": "C相有功功率",
    "smartCity.Home.943046-460": "总有功功率",
    "smartCity.Home.943046-461": "A相无功功率",
    "smartCity.Home.943046-462": "B相无功功率",
    "smartCity.Home.943046-463": "C相无功功率",
    "smartCity.Home.943046-464": "总无功功率",
    "smartCity.Home.943046-465": "请稍候",
    "smartCity.Home.943046-466": "未知",
    "smartCity.Home.943046-467": "处理情况",
    "smartCity.Home.943046-468": "未解决",
    "smartCity.Home.943046-469": "已解决",
    "smartCity.Home.943046-470": "设备数量",
    "smartCity.Home.943046-471": "最近7天设备异常情况",
    "smartCity.Home.943046-472": "异常次数",
    "smartCity.Home.943046-473": "微软雅黑",
    "smartCity.Home.943046-474": "对接成功！",
    "smartCity.Home.943046-475": "对接失败！",
    "smartCity.Home.943046-476": "未找到身份认证信息，请重新登录",
    "smartCity.Home.943046-477": "今日误报",
    "smartCity.Home.943046-478": "是否对设备进行$",

    //HomeBak1 -- 数据模式

    "smartCity.HomeBak1.282798-0": "切换首页",
    "smartCity.HomeBak1.282798-1": "警报",
    "smartCity.HomeBak1.282798-2": "是否退出当前账号？",
    "smartCity.HomeBak1.282798-3": "入口",
    "smartCity.HomeBak1.282798-4": "智慧用电",
    "smartCity.HomeBak1.282798-5": "安全用气",
    "smartCity.HomeBak1.282798-6": "当天报警已处理情况",
    "smartCity.HomeBak1.282798-7": "设备位置",
    "smartCity.HomeBak1.282798-8": "设备名称",
    "smartCity.HomeBak1.282798-9": "开关状态",
    "smartCity.HomeBak1.282798-10": "暂无状态信息",
    "smartCity.HomeBak1.282798-11": "操作日志",
    "smartCity.HomeBak1.282798-12": "时间",
    "smartCity.HomeBak1.282798-13": "操作",
    "smartCity.HomeBak1.282798-14": "设备种类",
    "smartCity.HomeBak1.282798-15": "平安监控",
    "smartCity.HomeBak1.282798-16": "设备状态",
    "smartCity.HomeBak1.282798-17": "最近7天设备异常情况",
    "smartCity.HomeBak1.282798-18": "历史报警条目列表",
    "smartCity.HomeBak1.282798-19": "暂无报警信息",
    "smartCity.HomeBak1.282798-20": "浙江省杭州市",
    "smartCity.HomeBak1.282798-21": "全部区域",
    "smartCity.HomeBak1.282798-22": "系统操作",
    "smartCity.HomeBak1.282798-23": "请选择此功能按钮进入后台界面",
    "smartCity.HomeBak1.282798-24": "改变数据1",
    "smartCity.HomeBak1.282798-25": "改变数据2",
    "smartCity.HomeBak1.282798-26": "门窗开关设备暂无详情",
    "smartCity.HomeBak1.282798-27": "在线线设备",
    "smartCity.HomeBak1.282798-28": "离线设备",
    "smartCity.HomeBak1.282798-29": "微断",
    "smartCity.HomeBak1.282798-30": "气感",
    "smartCity.HomeBak1.282798-31": "烟感",
    "smartCity.HomeBak1.282798-32": "燃气电磁阀",
    "smartCity.HomeBak1.282798-33": "已处理",
    "smartCity.HomeBak1.282798-34": "未处理",
    "smartCity.HomeBak1.282798-35": "外环",
    "smartCity.HomeBak1.282798-36": "内环",
    "smartCity.HomeBak1.282798-37": "日期",
    "smartCity.HomeBak1.282798-38": "异常次数",
    "smartCity.HomeBak1.282798-39": "浙江省-杭州市",
    "smartCity.HomeBak1.282798-40": "用户名称",
    "smartCity.HomeBak1.282798-41": "联系电话",
    "smartCity.HomeBak1.282798-42": "单位名称",

    //农业模式
    "smartCity.Home_bak2.049016-0": "警报",
    "smartCity.Home_bak2.049016-1": "是否退出当前账号？",
    "smartCity.Home_bak2.049016-2": "入口",
    "smartCity.Home_bak2.049016-3": "最近报警条目列表",
    "smartCity.Home_bak2.049016-4": "暂无报警信息",
    "smartCity.Home_bak2.049016-5": "最近报警已处理情况",
    "smartCity.Home_bak2.049016-6": "已处理",
    "smartCity.Home_bak2.049016-7": "今日已处理",
    "smartCity.Home_bak2.049016-8": "今日处理数：",
    "smartCity.Home_bak2.049016-9": "今日未处理",
    "smartCity.Home_bak2.049016-10": "今日未处理数：",
    "smartCity.Home_bak2.049016-11": "设备报警数",
    "smartCity.Home_bak2.049016-12": "当前报警住户",
    "smartCity.Home_bak2.049016-13": "当前报警住户数",
    "smartCity.Home_bak2.049016-14": "当前报警设备",
    "smartCity.Home_bak2.049016-15": "当前报警设备数",
    "smartCity.Home_bak2.049016-16": "设备在线列表",
    "smartCity.Home_bak2.049016-17": "当前设备在线数",
    "smartCity.Home_bak2.049016-18": "设备离线列表",
    "smartCity.Home_bak2.049016-19": "当前设备离线数",
    "smartCity.Home_bak2.049016-20": "设备状态",
    "smartCity.Home_bak2.049016-21": "设备位置",
    "smartCity.Home_bak2.049016-22": "设备名称",
    "smartCity.Home_bak2.049016-23": "开关状态",
    "smartCity.Home_bak2.049016-24": "暂无状态信息",
    "smartCity.Home_bak2.049016-25": "智慧用电",
    "smartCity.Home_bak2.049016-26": "安全用气",
    "smartCity.Home_bak2.049016-27": "操作日志",
    "smartCity.Home_bak2.049016-28": "时间",
    "smartCity.Home_bak2.049016-29": "设备",
    "smartCity.Home_bak2.049016-30": "操作",
    "smartCity.Home_bak2.049016-31": "暂无操作日志",
    "smartCity.Home_bak2.049016-32": "设备编号",
    "smartCity.Home_bak2.049016-33": "用户名称",
    "smartCity.Home_bak2.049016-34": "详细地址",
    "smartCity.Home_bak2.049016-35": "类型",
    "smartCity.Home_bak2.049016-36": "请处理",
    "smartCity.Home_bak2.049016-37": "处理",
    "smartCity.Home_bak2.049016-38": "误报",
    "smartCity.Home_bak2.049016-39": "暂无告警消息",
    "smartCity.Home_bak2.049016-40": "设备地址",
    "smartCity.Home_bak2.049016-41": "通讯时间",
    "smartCity.Home_bak2.049016-42": "合闸",
    "smartCity.Home_bak2.049016-43": "分闸",
    "smartCity.Home_bak2.049016-44": "暂无设备",
    "smartCity.Home_bak2.049016-45": "在线状态",
    "smartCity.Home_bak2.049016-46": "在线",
    "smartCity.Home_bak2.049016-47": "离线",
    "smartCity.Home_bak2.049016-48": "所属小区",
    "smartCity.Home_bak2.049016-49": "住户地址",
    "smartCity.Home_bak2.049016-50": "业主名称",
    "smartCity.Home_bak2.049016-51": "联系电话",
    "smartCity.Home_bak2.049016-52": "报警时间",
    "smartCity.Home_bak2.049016-53": "幢-$",
    "smartCity.Home_bak2.049016-54": "单元-$",
    "smartCity.Home_bak2.049016-55": "楼-$",
    "smartCity.Home_bak2.049016-56": "{0}幢-{1}单元-{2}楼-{3}房间",
    "smartCity.Home_bak2.049016-57": "暂无告警住户",
    "smartCity.Home_bak2.049016-58": "设备详情",
    "smartCity.Home_bak2.049016-59": "无",
    "smartCity.Home_bak2.049016-60": "所属城市",
    "smartCity.Home_bak2.049016-61": "省",
    "smartCity.Home_bak2.049016-62": "市",
    "smartCity.Home_bak2.049016-63": "区",
    "smartCity.Home_bak2.049016-64": "所属区域",
    "smartCity.Home_bak2.049016-65": "地址",
    "smartCity.Home_bak2.049016-66": "经度",
    "smartCity.Home_bak2.049016-67": "纬度",
    "smartCity.Home_bak2.049016-68": "幢",
    "smartCity.Home_bak2.049016-69": "单元",
    "smartCity.Home_bak2.049016-70": "楼层",
    "smartCity.Home_bak2.049016-71": "用户号",
    "smartCity.Home_bak2.049016-72": "业主姓名",
    "smartCity.Home_bak2.049016-73": "业主电话",
    "smartCity.Home_bak2.049016-74": "维修人姓名",
    "smartCity.Home_bak2.049016-75": "维修人电话",
    "smartCity.Home_bak2.049016-76": "维修人身份证号码",
    "smartCity.Home_bak2.049016-77": "维修时间",
    "smartCity.Home_bak2.049016-78": "维修信息",
    "smartCity.Home_bak2.049016-79": "维修人身份证图片",
    "smartCity.Home_bak2.049016-80": "确定",
    "smartCity.Home_bak2.049016-81": "报警信息",
    "smartCity.Home_bak2.049016-82": "设备报警",
    "smartCity.Home_bak2.049016-83": "设备'{0}'在{1}发生{2}报警，请及时处理",
    "smartCity.Home_bak2.049016-84": "查看详情",
    "smartCity.Home_bak2.049016-85": "对接成功！",
    "smartCity.Home_bak2.049016-86": "对接失败！",
    "smartCity.Home_bak2.049016-87": "未找到身份认证信息，请重新登录",
    "smartCity.Home_bak2.049016-88": "处理情况",
    "smartCity.Home_bak2.049016-89": "未处理",
    "smartCity.Home_bak2.049016-90": "今日误报",
    "smartCity.Home_bak2.049016-91": "提示",
    "smartCity.Home_bak2.049016-92": "是否对设备进行$",

    //设备列表
    "smartCity.HomeBakDeviceList.719300-0": "设备列表",
    "smartCity.HomeBakDeviceList.719300-1": "报警设备",
    "smartCity.HomeBakDeviceList.719300-2": "在线设备",
    "smartCity.HomeBakDeviceList.719300-3": "待处理设备",
    "smartCity.HomeBakDeviceList.719300-4": "最近报警设备",
    "smartCity.HomeBakDeviceList.719300-5": "设备名称",
    "smartCity.HomeBakDeviceList.719300-6": "请输入设备名称",
    "smartCity.HomeBakDeviceList.719300-7": "设备编码",
    "smartCity.HomeBakDeviceList.719300-8": "请输入设备编码",
    "smartCity.HomeBakDeviceList.719300-9": "设备类型",
    "smartCity.HomeBakDeviceList.719300-10": "搜索",
    "smartCity.HomeBakDeviceList.719300-11": "设备位置",
    "smartCity.HomeBakDeviceList.719300-12": "设备编号",
    "smartCity.HomeBakDeviceList.719300-13": "通讯时间",
    "smartCity.HomeBakDeviceList.719300-14": "是否在线",
    "smartCity.HomeBakDeviceList.719300-15": "开关状态",
    "smartCity.HomeBakDeviceList.719300-16": "操作",
    "smartCity.HomeBakDeviceList.719300-17": "在线",
    "smartCity.HomeBakDeviceList.719300-18": "离线",
    "smartCity.HomeBakDeviceList.719300-19": "确定给设备消音？",
    "smartCity.HomeBakDeviceList.719300-20": "消音",
    "smartCity.HomeBakDeviceList.719300-21": "召测",
    "smartCity.HomeBakDeviceList.719300-22": "确定分闸吗？",
    "smartCity.HomeBakDeviceList.719300-23": "分闸",
    "smartCity.HomeBakDeviceList.719300-24": "确定合闸吗？",
    "smartCity.HomeBakDeviceList.719300-25": "合闸",
    "smartCity.HomeBakDeviceList.719300-26": "确定关阀吗？",
    "smartCity.HomeBakDeviceList.719300-27": "关阀",
    "smartCity.HomeBakDeviceList.719300-28": "探头",
    "smartCity.HomeBakDeviceList.719300-29": "修改",
    "smartCity.HomeBakDeviceList.719300-30": "是否解除绑定？",
    "smartCity.HomeBakDeviceList.719300-31": "删除",
    "smartCity.HomeBakDeviceList.719300-32": "详情",
    "smartCity.HomeBakDeviceList.719300-33": "暂无设备信息",
    "smartCity.HomeBakDeviceList.719300-34": "业主姓名",
    "smartCity.HomeBakDeviceList.719300-35": "设备地址",
    "smartCity.HomeBakDeviceList.719300-36": "序号",
    "smartCity.HomeBakDeviceList.719300-37": "异常时间",
    "smartCity.HomeBakDeviceList.719300-38": "处理",
    "smartCity.HomeBakDeviceList.719300-39": "误报",
    "smartCity.HomeBakDeviceList.719300-40": "用户名称",
    "smartCity.HomeBakDeviceList.719300-41": "详细地址",
    "smartCity.HomeBakDeviceList.719300-42": "类型",
    "smartCity.HomeBakDeviceList.719300-43": "请选择",
    "smartCity.HomeBakDeviceList.719300-44": "微断设备",
    "smartCity.HomeBakDeviceList.719300-45": "气感设备",
    "smartCity.HomeBakDeviceList.719300-46": "烟感设备",
    "smartCity.HomeBakDeviceList.719300-47": "燃气电磁阀",
    "smartCity.HomeBakDeviceList.719300-48": "更改下标",
    "smartCity.HomeBakDeviceList.719300-49": "更改每页的大小",
    "smartCity.HomeBakDeviceList.719300-50": "请求超时",
    "smartCity.HomeBakDeviceList.719300-51": "操作密码",
    "smartCity.HomeBakDeviceList.719300-52": "请输入操作密码",
    "smartCity.HomeBakDeviceList.719300-53": "您的操作太频繁，请稍后...",
    "smartCity.HomeBakDeviceList.719300-54": "操作中",
    "smartCity.HomeBakDeviceList.719300-55": "提示",
    "smartCity.HomeBakDeviceList.719300-56": "召测中",
    "smartCity.HomeBakDeviceList.719300-57": "item设备",
    "smartCity.HomeBakDeviceList.719300-58": "是否对设备进行$",

    
    //监控列表
    "smartCity.Monitor.549773-0": "监控设备",
    "smartCity.Monitor.549773-1": "设备位置",
    "smartCity.Monitor.549773-2": "设备编号",
    "smartCity.Monitor.549773-3": "设备名称",
    "smartCity.Monitor.549773-4": "是否在线",
    "smartCity.Monitor.549773-5": "在线",
    "smartCity.Monitor.549773-6": "不在线",


    //设备详情
    "smartCity.HomeBakDeviceDetail.479422-0": "产品简介",
    "smartCity.HomeBakDeviceDetail.479422-1": "设备详情",
    "smartCity.HomeBakDeviceDetail.479422-2": "能耗统计",
    "smartCity.HomeBakDeviceDetail.479422-3": "南阳",
    "smartCity.HomeBakDeviceDetail.479422-4": "周口",
    "smartCity.HomeBakDeviceDetail.479422-5": "电量",
    "smartCity.HomeBakDeviceDetail.479422-6": "电压",
    "smartCity.HomeBakDeviceDetail.479422-7": "电流",
    "smartCity.HomeBakDeviceDetail.479422-8": "漏电",
    "smartCity.HomeBakDeviceDetail.479422-9": "有功功率",
    "smartCity.HomeBakDeviceDetail.479422-10": "报警数量",
    "smartCity.HomeBakDeviceDetail.479422-11": "气体浓度",
    "smartCity.HomeBakDeviceDetail.479422-12": "请求超时",
    "smartCity.HomeBakDeviceDetail.479422-13": "能耗",
    "smartCity.HomeBakDeviceDetail.479422-14": "总量",
    "smartCity.HomeBakDeviceDetail.479422-15": "设备",
    "smartCity.HomeBakDeviceDetail.479422-16": "内环",
    "smartCity.HomeBakDeviceDetail.479422-17": "日期",
    "smartCity.HomeBakDeviceDetail.479422-18": "异常次数"
}


// WEBPACK FOOTER //
// ./src/i18n/lang/Zh/smartCity-zh.js